var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-2"},[_c('SpinnerContainer',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.appConfig.isLoading),expression:"$store.state.appConfig.isLoading"}]}),_c('div',{ref:"plot",attrs:{"id":"pcaPlotContainer"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }